<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="700px"
              scrollable
    >
        <v-card v-if="item">
            <v-toolbar flat dense>
                <h2 class="text-h6 text-primary-700 text-ellipsis-overflow">{{ item.name }} Requirements</h2>
                <v-spacer></v-spacer>
                <v-btn class="mr-0" style="width: 35px; height: 35px" icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text  class="pa-6">
                <!-- <v-list two-line>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Company</v-list-item-title>
                            <v-list-item-subtitle>{{item.name}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list> -->
                <div>
                    <!-- <h3>Requirements</h3> -->
                    <v-simple-table style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th>Location</th>
                                <th>Min Size</th>
                                <th>Max Size</th>
                            </tr>
                            </thead>
                            <tbody v-if="item.requirements.data.length > 0">
                            <tr v-for="(requirement, index) in item.requirements.data" :key="index">
                                <td>{{ requirement.location }}</td>
                                <td>{{ requirement.min_size}}</td>
                                <td>{{ requirement.max_size}}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td class="text-center" :colspan="3">
                                    No requirements found
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: "companyRequirementsDialog",
		components: {
		},
		data: () => ({
			dialog: false,
			id: null,
			item: null,
		}),
		methods: {
			showDialog: function (id) {
				
				this.id = id;
				this.getItem();
			},
			async getItem() {
				const {data} = await this.$http.get(`/companies/${this.id}`, {
					params: {
						include: 'requirements',
					}
				});

				this.item = data;
                this.dialog = true;
			},
			closeDialog: function () {
				this.dialog = false;
				this.id = null;
				this.item = null;
				this.$emit('closed');
			},
		},
	}
</script>

<style scoped>

</style>